<template>
  <div class="alert-modal-wrapper">
    <a-modal
      id="alert-modal"
      v-model="visible"
      :title="null"
      :footer="null"
      :mask-closable="false"
      centered
      @close="handleClose"
    >
      <div class="content-wrapper">
        <a-icon v-if="success" type="check-circle" class="icon-success" />
        <a-icon v-if="!success" type="close-circle" class="icon-fail" />
        <div class="detail">
          <strong>
            {{ title }}
          </strong>
          <span>{{ messege }}</span>
        </div>
      </div>
    </a-modal>
  </div>
</template>
<script>
import CommonMixin from '@/mixin/CommonMixin'
import ResponsiveMixin from '@/mixin/ResponsiveMixin'

export default {
  name: 'AlertCreateModal',
  mixins: [CommonMixin, ResponsiveMixin],
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    success: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    messege: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      visible: false,
      imgLogo: null,
    }
  },
  watch: {
    show: {
      immediate: true,
      handler(val) {
        this.visible = val
      },
    },
  },
  methods: {
    handleClose() {
      this.$emit('close')
    },
  },
}
</script>
<style lang="scss" scoped>
#alert-modal {
  .content-wrapper {
    margin: 24px 16px 16px;
    text-align: center;
    display: flex;
    flex-direction: column;
    gap: 24px;

    .icon-fail {
      font-size: 120px;
      color: #ff5252;
    }
    .icon-success {
      font-size: 120px;
      color: #7ed321;
    }
    .detail {
      display: flex;
      flex-direction: column;
      gap: 4px;
      margin-bottom: 16px;

      strong {
        font-size: 20px;
        color: #424242;
      }
      span {
        font-size: 18px;
        color: #757575;
      }
    }
  }
}
</style>
